import * as $ from 'jquery';
import * as url from 'CMS/core/url';
import * as i18n from 'CMS/core/i18n';
import * as kendo from 'kendo/kendo.core';
import Widget, { IWidgetInitializeOptions } from 'CMS/core/Widget';
import NewsRepository from 'AWFNews/Data/Repositories/NewsRepository';
import News from 'AWFNews/Data/Entities/News';
import RecentNewsViewModel from 'AWFNews/ViewModels/RecentNews/RecentNewsViewModel';
import 'jquery/isotope';
import WebpageRepository from 'CMS/Data/Repositories/WebpageRepository';
import * as Constants from 'AWFNews/Constants';
import Criteria from 'AWFNews/Data/Entities/Criteria';

export default class RecentNews extends Widget {
    private $root: JQuery;
    private readonly newRepository: NewsRepository;
    private newsItems: News[] = [];
    private amount: number = 3;
    private category: string = null;
    private showThumb: boolean = false;
    private $recentNewsGrid: JQuery<HTMLElement>;
    private webpageRepository: WebpageRepository;

    public constructor() {
        super();

        this.newRepository = new NewsRepository();
        this.webpageRepository = new WebpageRepository();
    }

    public async initialize(options: IWidgetInitializeOptions) {
        // Internationalization
        this.$root = $(options.root);
        i18n.bind(this.$root);

        // Get amount of news items to show
        if (options.params != null) {
            let amount = Number(options.params.MaxNieuwsItems);

            if (amount != null && amount !== undefined && !isNaN(amount)) {
                this.amount = amount;
            }

            if (options.params.NieuwsCategory != null && options.params.NieuwsCategory !== undefined && options.params.NieuwsCategory != '') {
                this.category = options.params.NieuwsCategory
            }

            if (options.params.ShowThumb != null && options.params.ShowThumb !== undefined && options.params.ShowThumb != '') {
                this.showThumb = options.params.ShowThumb
            }
        }

        // Find and create grid
        this.$recentNewsGrid = this.$root.find('.items-container').isotope({
            itemSelector: '.recent-news-item'
        });

        // Get all news items
        this.newsItems = await this.fetchNewsItems();

        // Display newsItems
        this.displayRecentNewsItems();

        // More messages click handler
        this.$root.find('.show-all-container').click(async e => {
            e.preventDefault();

            // Get url
            const currentUrl = await this.webpageRepository.getWebpageURL(Constants.PageReferences.NEWS_OVERVIEW);

            if (currentUrl) {
                window.location.assign(currentUrl);
            }
        });
    }

    private async fetchNewsItems(): Promise<News[]> {
        let newsItems: News[] = [];

        const criteria = new Criteria();

        if (this.category != null && this.category !== undefined && this.category != '') {
            criteria.categories.push(this.category);
        }
        criteria.statuses.push(1); // Only published messages

        try {
            newsItems = await this.newRepository.getAllForCriteria(criteria);

            if (newsItems) {
                newsItems = newsItems.sort((a, b) => {
                    if (a.newsOrder === b.newsOrder) {
                        return a.newsTimeStamp > b.newsTimeStamp ? -1 : 1;
                    } else if (a.newsOrder < b.newsOrder) {
                        return -1;
                    } else {
                        return 1;
                    }
                });
            }
        } catch (e) {
            console.log(e);
        }

        return newsItems;
    }

    private displayRecentNewsItems() {
        const maxI = this.amount !== 0 ? Math.min(this.amount - 1, this.newsItems.length - 1) : this.newsItems.length - 1;

        // Display news item
        for (let i = 0; i <= maxI; i++) {
            if (this.newsItems[i] !== null) {
                this.displayRecentNewsItem(this.newsItems[i]);
            }
        }
    }

    private displayRecentNewsItem(item: News) {
        let itemTemplate: (data: any) => string;
        if (this.showThumb && item.headlineThumb != null && item.headlineThumb != undefined && item.headlineThumb != '') {
            itemTemplate = kendo.template(this.$root.find('#recentNewsTemplateWithThumb').html());
        } else {
            itemTemplate = kendo.template(this.$root.find('#recentNewsTemplate').html());
        }
        const viewModel = new RecentNewsViewModel(item);

        const html = itemTemplate(viewModel);
        const $gridItem = $(html);
        i18n.bind($gridItem);

        $gridItem.on('click', (e: JQuery.ClickEvent) => {
            this.showNewsItem(e);
        });

        this.$recentNewsGrid.isotope('insert', $gridItem);
    }

    private async showNewsItem(e: JQuery.ClickEvent) {
        let webPageUrl = await this.webpageRepository.getWebpageURL(Constants.PageReferences.NEWS_DETAIL);

        if (webPageUrl) {
            webPageUrl = url.updateUrlParameter(webPageUrl, 'NewsItem', $(e.currentTarget).data('id'));
            window.location.assign(webPageUrl);
        }
    }

    public destroy() {
    }
} 